import React from 'react'
import { StaticImage } from "gatsby-plugin-image"

export function PorcessReviewFive() {
  return (
    <section className="position-relative">
      <div className="container-lg">
        <StaticImage className="d-none d-md-block middle-icon position-absolute top-50 start-50 translate-middle" alt="quote-circle" src="../../../images/process/home/quote-circle.png" imgClassName="middle-icon" />
        <div className="row flex-sm-row-reverse">
          <div className="col-md-6 d-flex align-items-center justify-content-center text-with-quotes border-0">
            <figure className="text-center px-2 mb-0 limited-width">
              <blockquote>After only two treatments with Milan, I noticed <strong>my hair is already way thinner</strong> than before!</blockquote>
              <figcaption><strong>- Laura Novotny</strong></figcaption>
            </figure>
          </div>
          <div className="col-md-6 d-flex align-items-center justify-content-center milan-py-lg border-right">
            <StaticImage className="reviewer-img" alt="Laura Novotny Review" src="../../../images/process/home/laura.webp" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default PorcessReviewFive